import { networkService } from './networkService';

export interface IPushSubscriptionResponse {
  subscriptionId: number;
}

export interface IPushTopicSubscription {
  topic: string;
  config: Record<string, unknown> | null;
}

export interface IPushSubscriptionDetails {
  subscription: {
    id: number;
    isLinked: boolean;
  } | null;
  topics: IPushTopicSubscription[];
}

const pushNotificationApiService = {
  async getVapidKey(): Promise<{ publicKey: string }> {
    return networkService.get('/api/push/vapid-key');
  },

  async subscribe(endpoint: string, keys: { p256dh: string; auth: string }): Promise<IPushSubscriptionResponse> {
    return networkService.post('/api/push/subscribe', { endpoint, keys });
  },

  async unsubscribe(endpoint: string, auth: string): Promise<{ success: boolean }> {
    return networkService.delete('/api/push/subscribe', { endpoint, auth });
  },

  async getSubscription(endpoint: string): Promise<IPushSubscriptionDetails> {
    return networkService.post('/api/push/subscription', { endpoint });
  },

  async subscribeToTopic(
    subscriptionId: number,
    topic: string,
    endpoint: string,
    config?: Record<string, unknown>
  ): Promise<{ success: boolean }> {
    return networkService.post('/api/push/topics', { subscriptionId, topic, endpoint, config });
  },

  async unsubscribeFromTopic(subscriptionId: number, topic: string, endpoint: string): Promise<{ success: boolean }> {
    return networkService.delete('/api/push/topics', { subscriptionId, topic, endpoint });
  },

  async mergeSubscription(endpoint: string): Promise<{ success: boolean }> {
    return networkService.post('/api/push/merge', { endpoint });
  }
};

export default pushNotificationApiService;
